import type { SurchargeNoticeOverlay } from "@/types/api";

import { isRenderableSurcharge } from "./surchargeDisplay";

/** Index active surcharge-notice overlays by surcharge code. */
export function surchargeNoticeOverlayByCode(
  noticeOverlays?: SurchargeNoticeOverlay[] | null,
): Map<string, SurchargeNoticeOverlay> {
  const map = new Map<string, SurchargeNoticeOverlay>();
  for (const o of noticeOverlays ?? []) {
    if (!isRenderableSurcharge({ currency: o.currency })) continue;
    map.set(o.code.toUpperCase(), o);
  }
  return map;
}

export function surchargeNoticeAmountChanged(
  overlay: SurchargeNoticeOverlay,
): boolean {
  return Math.abs(overlay.original_amount - overlay.adjusted_amount) > 0.005;
}

/** Match an overlay to a displayed surcharge row (same code + line currency). */
export function resolveSurchargeNoticeOverlay(
  overlayByCode: ReadonlyMap<string, SurchargeNoticeOverlay>,
  code: string,
  lineCurrency: string,
): SurchargeNoticeOverlay | undefined {
  const overlay = overlayByCode.get(code.toUpperCase());
  if (!overlay) return undefined;
  if (
    (overlay.currency ?? "").toUpperCase() !== lineCurrency.toUpperCase()
  ) {
    return undefined;
  }
  return overlay;
}

/** Whether any notice overlay touches a surcharge in this category. */
export function categoryHasSurchargeNotice(
  surcharges: Array<{ code?: string | null; category?: string | null }>,
  category: "ocean" | "local",
  noticeOverlays?: SurchargeNoticeOverlay[] | null,
): boolean {
  const codes = surchargeNoticeOverlayByCode(noticeOverlays);
  if (codes.size === 0) return false;
  return surcharges.some(
    (s) =>
      s.category === category &&
      codes.has((s.code ?? "").toUpperCase()),
  );
}
